'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    title3ClassNames: function() {
        return title3ClassNames;
    },
    useTitle3Styles: function() {
        return useTitle3Styles;
    }
});
const _react = require("@griffel/react");
const title3ClassNames = {
    root: 'fui-Title3'
};
const useTitle3Styles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bahqtrf: "fk6fouc",
        Be2twd7: "f1x0m3f5",
        Bhrd7zp: "fl43uef",
        Bg96gwp: "fb86gi6"
    }
}, {
    d: [
        ".fk6fouc{font-family:var(--fontFamilyBase);}",
        ".f1x0m3f5{font-size:var(--fontSizeBase600);}",
        ".fl43uef{font-weight:var(--fontWeightSemibold);}",
        ".fb86gi6{line-height:var(--lineHeightBase600);}"
    ]
});
